
<template>
    <div class="audio-player">
      <audio ref="audio-player"></audio>
      <div class="audio-mock-player" v-if="isShowAudioPlayer">
        <img :src="closeIcon" class="closeicon" @click="closeAudioPlay" />
        <!-- "暂停" : "播放" -->
        <img
          @click="musicPlay('play')"
          class="play-sty"
          :src="play ? plozeIcon : playIcon"
        />
  
        <div class="right-menu">
          <div class="bottom">
            <!--  播放进度条 -->
            <el-slider
              class="progress"
              v-model="sliderVal"
              :format-tooltip="formatTooltip"
              :min="sliderMin"
              :max="sliderMax"
              @change="spliderSelect"
            />
  
            <span class="current">{{ currentTime }}</span>
            <span class="duration">/{{ duration }}</span>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      // 显示隐藏
      isShowAudioPlayer: {
        default: true,
      },
      audio:[String]
      // 播放列表
      // list: {
      //   default: function () {
      //     return [
      //       //数据格式
      //       {
      //         id: 1,
      //         name: "美人鱼",
      //         url: "../../../../assets/housework/1.mp3",
      //         cover: "ChenYou",
      //         singer: "林俊杰",
      //       },
      //       {
      //         id: 2,
      //         name: "起风了",
      //         url: "../../../../assets/housework/2.mp3",
      //         cover: "ChenYou",
      //         singer: "林俊杰",
      //       },
      //     ];
      //   },
      // },
      //  播放索引
      // index
    },
    data() {
      return {
        playIcon: require("../../../../assets/housework/btn_voice.png"),
        plozeIcon: require("../../../../assets/housework/voice48.gif"),
        // vulumnIcon: require("./asset/vulumn.png"),
        // mutedIcon: require("./asset/muted3.png"),
        closeIcon: require("../../../../assets/housework/delete.png"),
        box: undefined,
        index: 0, // 当前播放的音乐素质索引
        play: false, // 播放状态，true为正在播放
        sliderVal: 0, // 这个对接当前时长。
        sliderMin: 0,
        sliderMax: 0, // 这个对接总时长。
        sliderValVolumn: 0.5, // 音量
        copySliderValVolumn: 0.5,
        duration: undefined, // 音乐总时长
        currentTime: undefined, //当前播放时长
      };
    },
    watch: {
      audio(val) {
        this.init()
      }
    },
    mounted() {
      this.init();
    },
    methods: {
      init() {
        this.box = this.$refs["audio-player"];
        // http://192.168.1.101/api/uploads/voice/20230208/16758199067281179.mp3
        // this.box.src = "http://192.168.1.101/api/uploads/voice/20230208/16758199067281179.mp3";
        this.box.src = this.audio
        // console.log(this.box, "音频播放器DOM");
        const that = this;
  
        //  this.duration  =  this.formatTime(this.box.duration)
        // 绑定三个触发方法
        // 当时长有变化时触发，由"NaN"变为实际时长也算
        this.box.ondurationchange = function () {
          // console.log("时长发生了变化");
          // console.log(that.box.duration);
          // that.
          // that.duration  =  that.formatTime(that.box.duration)
          that.sliderMax = Math.floor(that.box.duration);
          that.updateTime();
        };
        // 当前数据可用是触发
        this.box.oncanplay = function () {
          // console.log("已经可以播放了");
        };
        // 播放位置发送改变时触发。
        this.box.ontimeupdate = function () {
          // console.log("播放位置发送了变动");
          that.updateTime();
        };
        // 音频播放完毕
        this.box.onended =  () => {
          this.play = !this.play
          // console.log("播放完毕，谢谢收听");
        };
        // 音频播放完毕
        this.box.onerror = function () {
          console.log("加载出错！");
        };
      },
      // changeVolumns() {
      //   // 静音切换
      //   if (this.sliderValVolumn > 0) {
      //     this.sliderValVolumn = 0;
      //   } else {
      //     this.sliderValVolumn = this.copySliderValVolumn;
      //   }
      // },
      // 播放
      musicPlay(flag) {
        switch (flag) {
          case "pre":
            if (this.list[this.index - 1]) {
              this.box.src = this.list[this.index - 1].url;
              this.index -= 1;
            } else {
              this.box.src = this.list[this.list.length - 1].url;
              this.index = this.list.length - 1;
            }
            this.init();
            if (this.play) {
              this.box.play();
            } else {
              this.box.pause();
            }
            break;
          case "play":
            this.play = !this.play;
            if (this.play) {
              this.box.play();
            } else {
              this.box.pause();
            }
            break;
          case "next":
            if (this.list[this.index + 1]) {
              this.box.src = this.list[this.index + 1].url;
              this.index += 1;
            } else {
              this.box.src = this.list[0].url;
              this.index = 0;
            }
            this.init();
            if (this.play) {
              this.box.play();
            } else {
              this.box.pause();
            }
            break;
        }
      },
      formatTooltip(val) {
        // 格式化毫秒数，由于组件提示为纯数字，所以这里需要将数字转化为我们所需要的的格式，string类型的。'03:45',
        const time = this.formatTime(val);
        return `${time.min}:${time.sec}`;
      },
      // 音量显示100%
      // formatTooltipVolumn(val) {
      //   return val * 100 + "%";
      // },
      spliderSelectVolumn() {
        this.box.volume = this.sliderValVolumn;
        // 备份音量
        this.copySliderValVolumn = this.sliderValVolumn;
      },
      updateTime() {
        const total = this.formatTime(this.box.duration);
        const current = this.formatTime(this.box.currentTime);
        this.duration = `${total.min}:${total.sec}`;
        this.currentTime = `${current.min}:${current.sec}`;
        // 值为xx.xxxxx 需要取整
        this.sliderVal = Math.floor(this.box.currentTime);
      },
      formatTime(time) {
        // 格式化毫秒，返回String型分秒对象
  
        if (!time) return { min: "00", sec: "00" };
        return {
          min: Math.floor(time / 60)
            .toString()
            .padStart(2, "0"),
          sec: Math.floor(time % 60)
            .toString()
            .padStart(2, "0"),
        };
      },
      closeAudioPlay() {
        // this.isShowAudioPlayer = false;
        this.$emit('closeAudioPlay')
      },
      spliderSelect() {
        // 滑块松动后触发。更新当前时长，
        // 时长发生变动会init里的方法进行更新数据
        this.box.currentTime = this.sliderVal;
      },
    },
  };
  </script>
  
  <style  lang='scss'>
  .poppervulumn-class {
    min-width: 20px !important;
    padding: 12px 5px !important;
  }
  .audio-player {
    .audio-mock-player {
      position: relative;
      // width: 523px;
      height: 38px;
      padding: 16px;
      box-sizing: border-box;
      background: #F5F5F5;
      border-radius: 4px;
      display: flex;
      align-items: center;
      .play-sty {
        margin: 0 5px 0 0;
        width: 24px;
        height: 24px;
      }
      .preicon {
        width: 32px;
        height: 32px;
      }
      .closeicon {
        position: absolute;
        right: 0px;
        top: 0px;
        width: 16px;
        height: 16px;
      }
      .right-menu {
        margin-left: 10px;
        flex: 1;
        .bottom {
          display: flex;
          align-items: center;
          .progress {
            flex: 1;
          }
          .current {
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #555555;
            text-align: left;
            font-weight: 400;
            margin-left: 12px;
          }
          .duration {
            opacity: 0.6;
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #555555;
            text-align: left;
            font-weight: 400;
            margin-right: 16px;
          }
        //   .vulumn {
        //     position: relative;
        //     img {
        //       width: 18.5px;
        //       height: 15px;
        //     }
        //     .vulumn-progress {
        //       position: absolute;
        //       top: -73px;
        //       left: -12px;
        //     }
        //   }
        }
      }
    }
  }
  </style>
  


// WEBPACK FOOTER //
// src/view/Panel/housework/components/TestAudio.vue